class ProductPicker {
  constructor() {
    this.offersGroups = document.querySelectorAll('.picker-dogsize_offers-group');
    this.offersItems = document.querySelectorAll('.picker-offer_input');
    this.dogSizeInputs = document.querySelectorAll('.picker-dogsize_input');
    this.purchaseTypeInput = document.getElementById('js__picker-purchase_type');
    this.dogSizesTrigger = document.getElementById('dogsizes-selector-trigger');
    this.dogsizesTarget = document.getElementById('dogsizes-selector-target');
    this.productForm = document.getElementById('product-picker-form');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.skipCart = this.productForm.dataset.skipCart !== undefined;
    this.subscriptionNotice = document.querySelector('subscription-notice');
    this.subscriptionNotice && this.subscriptionNotice.init(this);
    this.quantityInput = document.getElementById('product-quantity-picker');
    this.quantityMinus = document.querySelector('[data-quantity-minus]');
    this.quantityPlus = document.querySelector('[data-quantity-plus]');

    this.init();
  }

  init() {
    if (this.quantityInput) {
  this.quantityInput.addEventListener('change', () => {
    this.updateQuantityOffer();
    this.croUpdateCTA();
  });

  this.quantityMinus?.addEventListener('click', () => {
  const currentValue = Number(this.quantityInput.value) || 1;
  this.quantityInput.value = Math.max(1, currentValue - 1);
  this.updateQuantityOffer();
});

this.quantityPlus?.addEventListener('click', () => {
  const currentValue = Number(this.quantityInput.value) || 1;
  this.quantityInput.value = currentValue + 1;
  this.updateQuantityOffer();
});

}
    this.dogSizeInputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.updateOfferGroups();
        if (window.innerWidth < 950) {
          this.updateDogsizeSelector(input);
        }
      });
    });

    this.offersItems.forEach((offer) => {
      offer.addEventListener('change', () => this.updateCTA());
      offer.addEventListener('change', this.croUpdateCTA.bind(this));
    });

    // this.purchaseTypeInput.addEventListener('change', () => {
    //   this.updateOfferGroups();
    // });
    if (this.purchaseTypeInput) {
  this.purchaseTypeInput.checked = false;
  this.purchaseTypeInput.addEventListener('change', () => {
    this.purchaseTypeInput.checked = false;
    this.updateOfferGroups();
  });
}

    document.addEventListener('DOMContentLoaded', () => {
      this.updateOfferGroups();
    });

    this.dogSizesTrigger.addEventListener('click', () => {
      if (this.dogsizesTarget.classList.contains('dogsizes-hidden')) {
        this.dogsizesTarget.classList.remove('dogsizes-hidden');
      } else {
        this.dogsizesTarget.classList.add('dogsizes-hidden');
      }
    });

    this.productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();

      this.subscriptionNotice ? this.subscriptionNotice.open() : this.addToCart();
    });

    document.getElementById('cro-test-price').addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.addToCart();
    });

    document.getElementById('cro-price-button').addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.croAddToCartOTP();
    });

    // Synchronize offer inputs across groups
    this.offersGroups.forEach((group) => {
      group.addEventListener('change', (event) => {
        if (event.target.tagName === 'INPUT' && event.target.type === 'radio') {
          const selectedIndex = [...group.querySelectorAll('input[type="radio"]')].indexOf(event.target);
          this.syncOfferInputs(selectedIndex, group);
        }
      });
    });
  }

 getActiveOffer() {
    const activeGroup = [...this.offersGroups].find(
      (group) => window.getComputedStyle(group).display === 'block'
    );

    if (!activeGroup) return null;

    return (
      activeGroup.querySelector('.picker-offer_input:checked') ||
      activeGroup.querySelector('.picker-offer_input')
    );
  }

updateQuantityOffer() {
  if (!this.quantityInput) return;

  const quantity = Math.max(1, Number(this.quantityInput.value) || 1);
  this.quantityInput.value = quantity;

  this.croUpdateCTA();
}



  // updateCTA() {
  //   let activeOffersGroup = null;
  //   this.offersGroups.forEach((element) => {
  //     if (window.getComputedStyle(element).display === 'block') {
  //       activeOffersGroup = element;
  //       const activeOffer = activeOffersGroup.querySelector('.picker-offer_input:checked');
  //       const activeOfferPrice = activeOffer.getAttribute('data-discounted-price');
  //       const activeOfferDefaultPrice = activeOffer.dataset.defaultPrice;
  //       const activeOfferSAvePrice = activeOffer.dataset.savePrice;

  //       document.getElementById('picker-submit_btn-price_discounted').textContent = activeOfferPrice;
  //       document.getElementById('cro-picker-submit_btn-price_discounted').textContent = activeOfferPrice;
  //       document.getElementById('cro-picker-submit_btn-price_old').textContent = activeOfferDefaultPrice;
  //       document.getElementById('redesigned-picker__price-block__value').textContent = activeOfferDefaultPrice;
  //       document.getElementById('redesigned-picker__price-block-pay__value').textContent = activeOfferPrice;
  //       document.getElementById('redesigned-picker__price-block-save__value').textContent = activeOfferSAvePrice;
  //     }
  //   });
  // }

  // croUpdateCTA() {
  //   let activeOffersGroup = null;
  //   this.offersGroups.forEach((element) => {
  //     if (window.getComputedStyle(element).display === 'block') {
  //       activeOffersGroup = element;
  //       const activeOffer = activeOffersGroup.querySelector('.picker-offer_input:checked');
  //       const croOTPPrice = activeOffer.getAttribute('data-cro-discounted-price');

  //       // document.getElementById('cro-price').textContent = croOTPPrice;
  //       const croPrice = document.getElementById('cro-price');
  //       if (croPrice) croPrice.textContent = croOTPPrice;

  //     }
  //   });
  // }

  updateCTA() {
    const activeOffer = this.getActiveOffer();
    if (!activeOffer) return;

    const activeOfferPrice = activeOffer.getAttribute('data-discounted-price');
    const activeOfferDefaultPrice = activeOffer.dataset.defaultPrice;

    const priceDiscounted = document.getElementById('picker-submit_btn-price_discounted');
    const croPriceDiscounted = document.getElementById('cro-picker-submit_btn-price_discounted');
    const croPriceOld = document.getElementById('cro-picker-submit_btn-price_old');

    if (priceDiscounted) priceDiscounted.textContent = activeOfferPrice;
    if (croPriceDiscounted) croPriceDiscounted.textContent = activeOfferPrice;
    if (croPriceOld) croPriceOld.textContent = activeOfferDefaultPrice;
  }

  parseMoney(value) {
    return Number(String(value).replace(/[^0-9.-]+/g, '')) || 0;
  }

  formatMoney(amount, template) {
    const hasDecimals = String(template).includes('.');
    const currencyPrefix = String(template).replace(/[0-9.,\s-]/g, '') || '$';

    return `${currencyPrefix}${amount.toFixed(hasDecimals ? 2 : 0)}`;
  }

croUpdateCTA() {
  const activeOffer = this.getActiveOffer();
  if (!activeOffer) return;

  const cartQuantity = Math.max(1, Number(this.quantityInput?.value) || 1);
  const offerQuantity = Math.max(1, Number(activeOffer.dataset.quantity) || 1);

  const priceText =
    activeOffer.getAttribute('data-cro-discounted-price') ||
    activeOffer.getAttribute('data-discounted-price') ||
    activeOffer.getAttribute('data-default-price');

  const offerTotal = this.parseMoney(priceText);
  const unitPrice = offerTotal / offerQuantity;
  const cartTotal = unitPrice * cartQuantity;

  const discountedTarget = document.getElementById('otp-submit_btn-price_discounted');

  if (discountedTarget) {
    discountedTarget.textContent = this.formatMoney(cartTotal, priceText);
  }
}




  updateOfferGroups() {
    const purchaseType = 'otp';
    if (this.purchaseTypeInput) {
      this.purchaseTypeInput.checked = false;
    }

    this.offersGroups.forEach((group) => (group.style.display = 'none'));

    const activeInput = document.querySelector('.picker-dogsize_input:checked');
    if (activeInput) {
      const activeGroupId = activeInput.getAttribute('data-offers-group') + '-' + purchaseType;
      const activeGroup = document.getElementById(activeGroupId);
      if (activeGroup) {
        activeGroup.style.display = 'block';
      }
    }

    this.updateCTA();
    this.croUpdateCTA();
    this.updateQuantityOffer();
  }

  syncOfferInputs(selectedIndex, currentGroup) {
    this.offersGroups.forEach((otherGroup) => {
      if (otherGroup !== currentGroup) {
        const correspondingRadio = otherGroup.querySelectorAll('input[type="radio"]')[selectedIndex];
        correspondingRadio.checked = true;
      }
    });
  }

  // croAddToCartOTP() {
  //   let activeOffersGroup = null;
  //   this.offersGroups.forEach((element) => {
  //     if (window.getComputedStyle(element).display === 'block') {
  //       activeOffersGroup = element;
  //       const activeOffer = activeOffersGroup.querySelector('.picker-offer_input:checked'),
  //         quantity = activeOffer.getAttribute('data-quantity'),
  //         variantId = activeOffer.getAttribute('data-cro-variant-id'),
  //         sellingPlan = 'otp',
  //         klaviyoTagsArr = {};

  //       let productType = activeOffer.getAttribute('data-product-type'),
  //         dogSizeTitle = activeOffer.getAttribute('data-dogsize'),
  //         sellingPlanTitle = activeOffer.getAttribute('data-interval-title'),
  //         klaviyoTagName = '',
  //         klaviyoTagValue = '';

  //       if (dogSizeTitle !== '') {
  //         klaviyoTagName = productType + '-' + dogSizeTitle;
  //       } else {
  //         klaviyoTagName = productType;
  //       }

  //       if (dogSizeTitle !== '') {
  //         klaviyoTagValue = sellingPlanTitle.replace(' ', '-') + '-nosub';
  //       } else {
  //         klaviyoTagValue = quantity + '-nosub';
  //       }

  //       klaviyoTagsArr[klaviyoTagName] = klaviyoTagValue;

  //       const productData = {
  //         id: variantId,
  //         quantity: quantity,
  //         sections: this.cart.getSectionsToRender().map((section) => section.id),
  //         properties: {
  //           _klaviyo_custom_tag: klaviyoTagsArr,
  //         },
  //       };

  //       fetch(`${routes.cart_add_url}.js`, {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //           Accept: 'application/json',
  //         },
  //         body: JSON.stringify(productData),
  //       })
  //         .then((response) => response.json())
  //         .then((response) => {
  //           this.cart.renderContents(response);
  //         })
  //         .catch((e) => {
  //           console.error(e);
  //         })
  //         .finally(() => {
  //           if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
  //         });
  //     }
  //   });
  // }

 croAddToCartOTP() {
  const activeOffer = this.getActiveOffer();
  if (!activeOffer) return;

  const quantity = Math.max(1, Number(this.quantityInput?.value) || 1);

  const variantId =
    activeOffer.getAttribute('data-cro-variant-id') ||
    activeOffer.getAttribute('data-variant-id');

  const productData = {
    id: variantId,
    quantity,
    sections: this.cart?.getSectionsToRender?.().map((section) => section.id),
  };

  fetch(`${routes.cart_add_url}.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(productData),
  })
    .then((response) => response.json())
    .then((response) => {
      this.cart?.renderContents(response);
    })
    .catch(console.error)
    .finally(() => {
      if (this.cart && this.cart.classList.contains('is-empty')) {
        this.cart.classList.remove('is-empty');
      }
    });
}

  addToCart() {
    let activeOffersGroup = null;
    this.offersGroups.forEach((element) => {
      if (window.getComputedStyle(element).display === 'block') {
        activeOffersGroup = element;
        const activeOffer = activeOffersGroup.querySelector('.picker-offer_input:checked'),
          quantity = activeOffer.getAttribute('data-quantity'),
          variantId = activeOffer.getAttribute('data-variant-id'),
          sellingPlan = activeOffer.getAttribute('data-selling-plan'),
          klaviyoTagsArr = {};

        let productType = activeOffer.getAttribute('data-product-type'),
          dogSizeTitle = activeOffer.getAttribute('data-dogsize'),
          sellingPlanTitle = activeOffer.getAttribute('data-interval-title'),
          klaviyoTagName = '',
          klaviyoTagValue = '';

        if (dogSizeTitle !== '') {
          klaviyoTagName = productType + '-' + dogSizeTitle;
        } else {
          klaviyoTagName = productType;
        }

        if (sellingPlan !== 'otp') {
          klaviyoTagValue = sellingPlanTitle.replace(' ', '-') + '-sub';
        } else {
          if (dogSizeTitle !== '') {
            klaviyoTagValue = sellingPlanTitle.replace(' ', '-') + '-nosub';
          } else {
            klaviyoTagValue = quantity + '-nosub';
          }
        }

        klaviyoTagsArr[klaviyoTagName] = klaviyoTagValue;
        const _source_type = document.body.dataset.sourceType;
        const _source_id = document.body.dataset.sourceId;
        const _source_handle = document.body.dataset.sourceHandle;

        const productData = {
          id: variantId,
          quantity: quantity,
          sections: this.skipCart ? null : this.cart.getSectionsToRender().map((section) => section.id),
          properties: {
            _klaviyo_custom_tag: klaviyoTagsArr, //JSON.stringify(klaviyoTagsArr),
            _source_type,
            _source_id,
            _source_handle,
          },
        };

        if (sellingPlan !== 'otp') {
          productData.selling_plan = sellingPlan;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(productData),
        })
          .then((response) => response.json())
          .then((response) => {
            if (!this.skipCart) this.cart.renderContents(response);
            else window.location.href = '/checkout';
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          });
      }
    });
  }

  updateDogsizeSelector(dogsize) {
    const dogsizeText = dogsize.getAttribute('data-dogsize-title');
    this.dogSizesTrigger.textContent = dogsizeText;
    this.dogsizesTarget.classList.add('dogsizes-hidden');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const newPicker = new ProductPicker();
  newPicker.updateOfferGroups();
  newPicker.updateCTA();
  newPicker.croUpdateCTA();
});

class DeliveryTimer {
  constructor() {
    if (document.querySelector('.delivery-timer')) {
      this.initTimer();
    }
  }

  initTimer() {
    this.updateDeliveryTimer();
    setInterval(() => this.updateDeliveryTimer(), 1000);
  }

  updateDeliveryTimer() {
    const now = new Date();
    const targetTime = new Date(now);
    targetTime.setUTCHours(12, 0, 0, 0);

    const wrapper = document.querySelector('.delivery-timer');

    if (now.getUTCHours() >= 12) {
      targetTime.setUTCDate(targetTime.getUTCDate() + 1);
      wrapper.classList.remove('before_noon');
      wrapper.classList.add('after_noon');
    } else {
      wrapper.classList.remove('after_noon');
      wrapper.classList.add('before_noon');
    }

    const diff = targetTime.getTime() - now.getTime();

    const hours = this.formatTimeUnit(Math.floor(diff / (1000 * 60 * 60)));
    const minutes = this.formatTimeUnit(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)));
    const seconds = this.formatTimeUnit(Math.floor((diff % (1000 * 60)) / 1000));

    document.querySelector('.timer').innerHTML = `${hours} : ${minutes} : ${seconds}`;
  }

  formatTimeUnit(unit) {
    return unit < 10 ? '0' + unit : unit;
  }
}

// Initialize the DeliveryTimer class when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  new DeliveryTimer();
});

document.addEventListener('DOMContentLoaded', function () {
  const checkbox = document.getElementById('js__picker-purchase_type');
  const wrapper = document.querySelector('.picker-purchase_type-wrapper');

  function toggleActiveClass() {
    if (checkbox.checked) {
      wrapper.classList.add('active');
    } else {
      wrapper.classList.remove('active');
    }
  }

  toggleActiveClass();

  checkbox.addEventListener('change', toggleActiveClass);
});

class SubscriptionNotice extends HTMLElement {
  constructor() {
    super();

    this.continueButton = this.querySelector('button');
    this.accountButton = this.querySelector('a');
    this.header = document.querySelector('header').parentElement;
    this.currentProductSku = this.dataset.sku;
    this.userCurrentSubscriptions = localStorage.getItem('user-current-subs') || [];
    this.accountLink = this.header.querySelector('.js__recharge_login_link')?.href;
    this.picker = false;
  }

  init(picker) {
    this.picker = picker;
    this.purchaseTypeInput = this.picker.purchaseTypeInput;
    this.picker ? this.continueButton.addEventListener('click', this.close.bind(this)) : null;
    this.accountLink = this.header.querySelector('.js__recharge_login_link')?.href;

    if (this.accountLink) this.accountButton.href = this.accountLink;
  }

  open() {
    const isSubscription = this.picker.purchaseTypeInput.checked;

    if (this.picker) {
      if (isSubscription && this.userCurrentSubscriptions.includes(this.currentProductSku)) {
        this.setAttribute('shown', '');
        this.header.classList.add('hidden');
        document.body.classList.add('overflow-hidden');
      } else {
        this.picker.addToCart();
      }
    }
  }

  close(event) {
    event.preventDefault();

    this.removeAttribute('shown');
    this.header.classList.remove('hidden');
    document.body.classList.remove('overflow-hidden');

    this.picker ? this.picker.addToCart() : null;
  }
}
customElements.define('subscription-notice', SubscriptionNotice);
